import React, { Component } from 'react';
import styles from './styles/signature.module.css';

class Signature extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div>
          Powered by{' '}
          <img
            width={36}
            style={{ verticalAlign: 'middle' }}
            src={`${import.meta.env.BASE_URL}/elay.png`}
          ></img>{' '}
        </div>
      </div>
    );
  }
}

export default Signature;
